import React from "react";
import { PageHeader } from "antd";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import PhysicalFitnessEnrollmentEntry from "../../components/enrollment/physicallfitness/PhysicalFitnessEnrollmentEntry";

const PhysicallFitnessEnrollment = () => {
  return (
    <div className="inside-main-content" >
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Enrollment - Physical Fitness (Tax Invoice With GST)"
          subTitle=""
          extra={[]}
        ></PageHeader>

        <PhysicalFitnessEnrollmentEntry />
      </div>
    </div>
  );
};

export default PhysicallFitnessEnrollment;
